import type { IMenuData } from "@/components/TabBar/index.d";
import { getMenus } from "@/service/account";
import { useMount, useRequest } from "ahooks";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";

interface IOptions {
  onSuccess?: () => void;
}

const NO_MENUS_URLS = [
  "/agreement",
  "/privacy",
  "/services",
  "/children",
  "/sharegame",
  "/threeshare",
  "/person"
];

export default (options?: IOptions) => {
  const history = useHistory();
  const { data, run: fetchMenus } = useRequest<IMenuData>(getMenus, {
    manual: true,
    onSuccess: options?.onSuccess
  });

  const hasMenuBar = useMemo(() => {
    if (NO_MENUS_URLS.includes(history.location.pathname.toLowerCase())) {
      return false;
    }
    return true;
  }, [history.location.pathname]);

  useMount(() => {
    const ignoreLoadMenus = NO_MENUS_URLS.includes(
      window.location.pathname.toLowerCase().slice(4)
    );
    if (!ignoreLoadMenus) {
      fetchMenus();
    }
  });

  return {
    menus: data?.data?.menu,
    hasMenuBar,
  };
};
